<template>
  <div>
    <div ref="fbdiv" :id="domId" class="fretboard" @click="onClick"></div>
  </div>
</template>

<script>
import { Fretboard, noteName, absNote } from "fretboards";
import { mapState } from "vuex";

export default {
  name: "Fretboard",
  props: {
    notes: { type: String, required: true },
    startFret: { type: Number, default: 0 },
    frets: { type: Number, default: 5 },
    fretWidth: { type: Number, default: 32 },
    fretHeight: { type: Number, default: 22 },
    noteClicked: { type: Function }
  },
  data() {
    return { fretboard: null, allNotes: [] };
  },
  created() {
    this.domId = "FB-" + Math.floor(Math.random() * 10000);
    this.unwatchHand = this.$store.watch(
      state => state.preferences.leftHanded,
      () => {
        this.fretboard.leftHanded = this.leftHanded;
        this.fretboard.repaint();
      }
    );
    this.unwatchTuning = this.$store.watch(
      state => state.preferences.tuning,
      () => {
        this.fretboard.tuning = this.tuning;
        this.fretboard.repaint();
      }
    );
  },
  beforeDestroy() {
    this.unwatchHand();
    this.unwatchTuning();
  },
  mounted() {
    this.fretboard = new Fretboard({
      where: "#" + this.domId,
      frets: this.startFret + this.frets,
      startFret: this.startFret,
      fretWidth: this.fretWidth,
      fretHeight: this.fretHeight,
      leftHanded: this.leftHanded,
      tuning: this.tuning,
      showTitle: true
    });
    this.fretboard.add(this.notes).paint();
  },
  updated() {
    this.fretboard
      .clearNotes()
      .add(this.notes)
      .paint();
  },
  computed: {
    ...mapState("preferences", ["tuning", "leftHanded"])
  },
  watch: {
    notes: {
      handler() {
        this.repaint();
      }
    },
    frets: {
      handler() {
        this.repaint();
      }
    },
    startFret: {
      handler() {
        this.repaint();
      }
    }
  },
  methods: {
    repaint() {
      if (this.fretboard) {
        this.fretboard.frets = this.frets + this.startFret;
        this.fretboard.startFret = this.startFret;
        this.fretboard.clearNotes();
        this.fretboard.add(this.notes);
        this.fretboard.repaint();
      }
    },
    onClick(event) {
      const value = this.getNote(event.offsetX, event.offsetY);
      if (value) {
        const [string, note] = value;
        if (this.noteClicked) {
          this.noteClicked({ string, note });
        }
      }
    },
    getNote(x, y) {
      const fret = Math.floor(x / this.fretWidth) + this.startFret;
      const string = Math.floor((y + this.fretHeight / 2) / this.fretHeight);
      if (
        1 <= string &&
        string <= 6 &&
        fret <= this.startFret + this.frets &&
        fret >= this.startFret
      ) {
        // Figure out the pitch and name of this note
        let pitch = absNote(this.tuning[6 - string]) + fret;
        let note = noteName(pitch);
        return [string, note];
      }
    }
  }
};
</script>

<style scoped>
.fretboard {
  color: black;
  background-color: #0000;
  overflow: hidden;
  line-height: 1rem;
}
</style>
